module.exports = __webpack_public_path__ + "img/speaker_33.5476cbd0.jpg";